import { render, staticRenderFns } from "./ConsultaPagoTasa.vue?vue&type=template&id=2a2d478c&scoped=true&"
import script from "./ConsultaPagoTasa.vue?vue&type=script&lang=js&"
export * from "./ConsultaPagoTasa.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaPagoTasa.vue?vue&type=style&index=0&id=2a2d478c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d478c",
  null
  
)

export default component.exports